import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-simple-quiz-moving-on-rw',
  templateUrl: './page-activity-simple-quiz-moving-on-rw.component.html',
  styleUrls: ['./page-activity-simple-quiz-moving-on-rw.component.css','../module-page-rw/module-page-rw.component.css']
})
export class PageActivitySimpleQuizMovingOnRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  flag = false;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  model7 = {
    model7_Q1: undefined,
    model7_Q2: undefined,
    model7_Q3: undefined,
    model7_Q4: undefined,
    model7_Q5: undefined,
    model7_Q6: undefined,
    model7_Q7: undefined,
  };

  model7_Q1 = false;
  model7_Q2 = false;
  model7_Q3 = false;
  model7_Q4 = false;
  model7_Q5 = false;
  model7_Q6 = false;
  model7_Q7 = false;

  m7_Q1() {
    this.model7_Q1 = true;
  }
  m7_Q2() {
    this.model7_Q2 = true;
  }
  m7_Q3() {
    this.model7_Q3 = true;
  }
  m7_Q4() {
    this.model7_Q4 = true;
  }
  m7_Q5() {
    this.model7_Q5 = true;
  }
  m7_Q6() {
    this.model7_Q6 = true;
  }
  m7_Q7() {
    this.model7_Q7 = true;
  }

  setFlag()
  {
    this.flag = true;
  }
  resetFlag()
  {
    this.flag = false;
  }

  activityOneCorrect()
  {
    /*
      If a question is not picked, return false
    */
    if (!this.model7_Q1 || !this.model7_Q2 || !this.model7_Q3 || !this.model7_Q4 || !this.model7_Q5 || !this.model7_Q6 || !this.model7_Q7)
      //If any are true, then return false
   {
    return false;
   }

   if (this.model7.model7_Q1 == true|| this.model7.model7_Q2 == true ||  this.model7.model7_Q3 == true|| this.model7.model7_Q4 == true|| this.model7.model7_Q5 == true
      || this.model7.model7_Q6 == true || this.model7.model7_Q7 == true)
   {
      return false;
   }

   /*
    Default: return true
   */
   return true;
  }
}
